<script setup lang="ts">
import type { EmailFrequency } from '@/types/Notifications';

defineProps<{
  modelValue: EmailFrequency;
  id: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: EmailFrequency];
}>();

function handleChange(event: Event): void {
  emit('update:modelValue', (event.target as HTMLSelectElement).value as EmailFrequency);
}
</script>

<template>
  <select
    :id="id"
    :value="modelValue"
    :disabled="disabled"
    class="select select-xs"
    @change="handleChange">
    <option value="DAILY">Daily</option>
    <option value="WEEKLY">Weekly</option>
  </select>
</template>
